import imageCompression from 'browser-image-compression';

export const IMAGE_CONFIG = {
  MAX_WIDTH: 287,
  MAX_HEIGHT: 200,
  MAX_SIZE_MB: 5,
  INITIAL_QUALITY: 0.5,
};

interface PhotoSize {
  width: number;
  height: number;
}

const photoCompressOptions = (maxSize?: number) => ({
  maxSizeMB: IMAGE_CONFIG.MAX_SIZE_MB,
  maxWidthOrHeight: maxSize || IMAGE_CONFIG.MAX_WIDTH,
  initialQuality: IMAGE_CONFIG.INITIAL_QUALITY,
});

export const getPreviewSize = (
  size: PhotoSize,
  maxWidth: number = IMAGE_CONFIG.MAX_WIDTH,
  maxHeight: number = IMAGE_CONFIG.MAX_HEIGHT
): PhotoSize => {
  if (size.width < maxWidth && size.height < maxHeight) {
    return { width: size.width, height: size.height };
  }
  const width = Math.floor((maxHeight * size.width) / size.height);
  const height =
    width > maxWidth
      ? Math.floor((size.height * maxWidth) / size.width)
      : maxHeight;

  return { width: width > maxWidth ? maxWidth : width, height };
};

export const compressPhoto = async (photo: File, maxSize?: number) => {
  try {
    return await imageCompression(photo, photoCompressOptions(maxSize));
  } catch (error) {
    console.error('Error compressing photo:', error);
    return null;
  }
};
